export default (name) => () => import(`@/views${name}.vue`)


// WEBPACK FOOTER //
// ./src/utils/menuList.js